<template>
    <div class="freeDelivery">
        <div class="freeDelivery__text">
            <template v-if="basket.hasFreeTransport">
                {{ $t('components.BasketContent.freeTransport.freeTransport') }}.
            </template>
            <template v-else>
                <span v-if="freeLimitPercentage < 100">
                    {{ $t('components.BasketContent.freeTransport.only') }}
                    <span class>{{ freeTransportDiff }}</span>
                    {{ $t('components.BasketContent.freeTransport.andTransportIsFree') }}
                </span>
                <span v-else>
                    {{ $t('components.BasketContent.freeTransport.freeTransport') }}.
                </span>
                <div class="js-tooltip tooltip tooltip--dark ml-1">
                    <span class="tooltip__icon">?</span>
                    <div class="tooltip__window">
                        <div class="description">
                            {{ $t('components.BasketContent.freeTransport.above') }} {{ freeTransportLimit }}
                            {{ $t('components.BasketContent.freeTransport.getTransportFree') }}
                            {{ $t('components.BasketContent.freeTransport.priceIsComputed') }}
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="freeDelivery__progress" v-if="freeLimitPercentage < 100 && !basket.hasFreeTransport">
            <div class="freeDelivery__progressInner" :style="{width: freeLimitPercentage + '%'}"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BasketFreeDelivery",
    props: {
        basket: {}
    },
    computed: {
        currentTotalPrice: function () {
            let totalPrice = this.basket.totalDiscountPrice.priceWithVat;
            // const user = this.getUser()
            // totalPrice = totalPrice - user.creditsDiscount
            return totalPrice;
        },
        freeTransportDiff: function () {
            let diff = this.getFreeLimit - this.currentTotalPrice;

            if (diff > this.getFreeLimit) {
                diff = this.getFreeLimit;
            }

            if (diff < 0) {
                diff = 0;
            }

            const increment = Math.pow(10, this.basket.totalDiscountPrice.currency.rounding);
            const diffRounded = Math.round(diff * increment) / increment;
            return diffRounded + " " + this.basket.totalDiscountPrice.currency.htmlString;
        },
        freeTransportLimit: function () {
            return this.getFreeLimit + " " + this.basket.totalDiscountPrice.currency.htmlString;
        },
        freeLimitPercentage: function () {
            let percentage = Math.round(100 * this.currentTotalPrice / this.getFreeLimit);
            if (percentage > 100) {
                percentage = 100;
            }
            return percentage;
        },
        getFreeLimit: function () {
            return this.$store.getters.freeTransportLimit;
        }
    },
    methods: {
        getUser: function () {
            return this.$store.getters.user;
        }
    }
}
</script>

<style scoped>

</style>
